import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Textinput, Flex, theme, FilePreview } from '../../../../ui';
import FileUploader from '../../../media/uploaders/FileUploader';
import { getDarkerThemeColor, getLighterThemeColor } from '../../../../ui/theme/colors';

const TextType = ({ data, taskRef, onSubmit, themeColor }) => {
  const { t } = useTranslation();
  const [answerFiles, setAnswerFiles] = useState([]);
  const [textValue, setTextValue] = useState('');

  const deleteAnswerFile = useCallback(
    (file) => {
      const result = answerFiles.filter((el) => el.id !== file.id);
      setAnswerFiles(result);
    },
    [answerFiles]
  );

  const submitTaskAnswer = () => {
    let finalAnswer = taskRef.current[data.taskId].value;

    if (answerFiles.length > 0) {
      answerFiles.forEach((file) => {
        finalAnswer += `[file:${file.id}]`;
      });
    }
    !!finalAnswer.length && onSubmit([finalAnswer]);
    setAnswerFiles([]);
    setTextValue('');
    taskRef.current[data.taskId].value = '';
  };

  return (
    <Flex direction='column' gap='10' align='flex-start'>
      <Textinput
        placeholder={t('globals.answer')}
        isMultiline
        minRows={3}
        maxRows={5}
        inputRef={(ref) => (taskRef.current[data.taskId] = ref)}
        onChange={(e) => setTextValue(e.target.value)}
      />
      {!!answerFiles.length && (
        <Flex direction='column' gap='8' width='100%' align='flex-start'>
          {answerFiles.map((file) => (
            <FilePreview key={file.id} file={file} onRemove={() => deleteAnswerFile(file)} compact />
          ))}
        </Flex>
      )}
      <Flex gap='10' justify='space-between' width='100%'>
        <FileUploader
          id={'taskAddFile'}
          saveAction={(callbackFile) => setAnswerFiles((prevFiles) => [...prevFiles, callbackFile])}
          label={t('globals.attachFile')}
          bgcolor={getLighterThemeColor(themeColor)}
          noMediaLibrary
        />
        <Button
          $variant='customized'
          $bgcolor={getDarkerThemeColor(themeColor) || theme.colors.PRIMARY}
          onClick={submitTaskAnswer}
          disabled={!textValue.trim() && answerFiles.length === 0}
        >
          {t('globals.submit')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default TextType;
